module.exports = __webpack_public_path__ + "img/feeliate-logo.f26a205b.svg";